import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function ImageGallery({ images = [], alt = "" }) {
  const [idx, setIdx] = useState(0);
  if (!images.length) return null;
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);
  return (
    <div className="space-y-3" data-testid="event-gallery">
      <div className="relative rounded-3xl overflow-hidden border border-black/10 bg-white">
        <div className="aspect-[16/10] bg-gray-100">
          <img
            src={images[idx]}
            alt={alt}
            className="w-full h-full object-cover transition-opacity duration-300"
            key={idx}
          />
        </div>
        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              data-testid="gallery-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/90 hover:bg-white grid place-items-center shadow"
              aria-label="Previous image"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={next}
              data-testid="gallery-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white/90 hover:bg-white grid place-items-center shadow"
              aria-label="Next image"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-1.5 bg-black/50 backdrop-blur rounded-full px-3 py-1.5">
              {images.map((_, i) => (
                <span
                  key={i}
                  className={`block h-1.5 rounded-full transition-all ${
                    i === idx ? "bg-white w-5" : "bg-white/50 w-1.5"
                  }`}
                />
              ))}
            </div>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="flex gap-2 overflow-x-auto hide-scrollbar">
          {images.map((src, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              data-testid={`gallery-thumb-${i}`}
              className={`shrink-0 h-16 w-24 rounded-lg overflow-hidden border-2 transition-all ${
                i === idx ? "border-[#FA003F]" : "border-transparent opacity-70 hover:opacity-100"
              }`}
            >
              <img src={src} alt="" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
